import http, { handleApiResponse, checkResponse, handleApiResponseWithSuccess } from "@/services/http"
import ApiResponse from "@/models/ApiResponse"
import GeneralObjectMarkTag from "../models/GeneralObjectMarkTag";
import GeneralObjectMarkItem from "../models/GeneralObjectMarkItem";
import GeneralObjectMarkHead from "../models/GeneralObjectMarkHead";

export default class ObjectMarkApi {

  //---------- Item ----------//

  static getItemObjectMarkTags(tableRelation: string, transactionId: number): Promise<GeneralObjectMarkItem[]> {
    return http.get<ApiResponse<GeneralObjectMarkItem[]>>(`object-mark/items/${tableRelation}/${transactionId}`)
      .then(handleApiResponse);
  }

  static addObjectMarkTagToItem(transactionId: number, generalObjectMarkTag: GeneralObjectMarkTag): Promise<void> {
    return http.post<ApiResponse<void>>(`object-mark/item/add/${transactionId}`, generalObjectMarkTag)
      .then(handleApiResponse);
  }

  static removeObjectMarkTagFromItem(objectMarkItem: GeneralObjectMarkItem): Promise<void> {
    return http.post<ApiResponse<void>>(`object-mark/item/remove`, { objectMarkItem: objectMarkItem })
      .then(handleApiResponse);
  }

  static copyObjectMarkTagsToAllItems(objectMarkHeadId: number, tableRelation: string, withFullDelete: boolean): Promise<void> {
    return http.post<ApiResponse<void>>(`object-mark/item/copy-to-all-items/${objectMarkHeadId}/${tableRelation}/${withFullDelete}`)
      .then((data) => handleApiResponseWithSuccess(data, "Címkék sikeresen másolva."));
  }

  //---------- Tag ----------//

  static getObjectMarkTagsByTableRelation(tableRelation: string): Promise<GeneralObjectMarkTag[]> {
    return http.get<ApiResponse<GeneralObjectMarkTag[]>>(`object-mark/tags/${tableRelation}`)
      .then(handleApiResponse);
  }

  static updateObjectMarkTag(objectMarkTag: GeneralObjectMarkTag): Promise<GeneralObjectMarkTag> {
    return http.post<ApiResponse<GeneralObjectMarkTag>>(`object-mark/tag/update`, { generalObjectMarkTag: objectMarkTag })
      .then(handleApiResponseWithSuccess);
  }
}
